import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { Allow, remult } from "remult";
import { type Status } from "./entity";

export const StatusEntityConfig: HyperEntityConfig<Status> = {
  allowApiRead: Roles.AdminsAndManager,
  allowApiCrud: Roles.AdminsAndManager,
  apiPrefilterPerRole: (filter) => {
    if (!remult.user) return;

    filter(Roles.SuperDuperAdmin, false);

    filter(Roles.SuperAdmin, true);

    filter(Roles.OrganizationManagers, {
      organization: {
        $id: remult.user.organizationId,
      },
    });

    filter(Roles.User, false);
  },

  allowInsertPerRole(allow) {
    allow(Roles.SuperAdmin, true);
  },

  allowDeleteAndUpdatePerRole(allow) {
    allow(Roles.SuperAdmin, {
      organization: {
        $id: remult.user!.organizationId,
      },
    });
  },
};
